"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesRanksElement = void 0;
const react_1 = __importDefault(require("react"));
const rich_content_1 = require("../rich-content");
const styles_1 = require("./styles");
const SalesRanksElement = (props) => {
    const ranksToRender = [];
    props.ranks.map((value, index) => {
        ranksToRender.push(react_1.default.createElement(styles_1.StyledSpan, { key: 'sellersRank' + index, font: "base", color: "secondary", "data-cy": "attribute-value" },
            react_1.default.createElement(rich_content_1.RichContentElement, { key: `sales_rank_${index}`, color: "secondary" }, Object.values(value)[0])));
    });
    return react_1.default.createElement(react_1.default.Fragment, null, ranksToRender);
};
exports.SalesRanksElement = SalesRanksElement;
